export const DOCTYPE = {
  LINK: "DOCTYPE_LINK",
  ADMIN_TASKS: "DOCTYPE_ADMIN_TASKS",
  // Notifications Center
  NOTIF_CENTER: "DOCTYPE_NOTIF_CENTER",
  // About
  ABOUT: "DOCTYPE_ABOUT",
  // User Preferences
  USER_PREFERENCES: "USER_PREFERENCES",
  // Assistant RE/SR Daily Reports
  ADR: "DOCTYPE_ADR", // Assistant RE/SR Daily Report form
  ADR_LIST: "DOCTYPE_ADR_LIST", // Index of Assistant RE/SR Daily Report
  ADR_SEARCH_RESULTS: "DOCTYPE_ADR_SEARCH_RESULTS",
  CEM4601: "PDF_DOCTYPE_CEM4601",
  CEM4501: "PDF_DOCTYPE_CEM4501",
  // Reports
  REPORT_SELECTION: "REPORT_SELECTION",
  REPORT_LABOR_WEEKLY: "DOCTYPE_REPORT_LABOR_WEEKLY",
  REPORT_WORK_PERFORMED: "DOCTYPE_REPORT_WORK_PERFORMED",
  REPORT_SELECTION: "DOCTYPE_REPORT_SELECTION",
  REPORT_CONTRACTOR_WEEKLY: "DOCTYPE_REPORT_CONTRACTOR_WEEKLY",
  REPORT_ITEM_EST_QUANTITIES: "DOCTYPE_REPORT_ITEM_EST_QUANTITIES",
  REPORT_PAYMENT_STATUS: "DOCTYPE_REPORT_PAYMENT_STATUS",
  REPORT_COMMENT_KEYWORD: "DOCTYPE_REPORT_COMMENT_KEYWORD",
  REPORT_OVERTIME: "DOCTYPE_REPORT_OVERTIME",
  REPORT_WSWD: "DOCTYPE_REPORT_WSWD",
  REPORT_CCO: "DOCTYPE_REPORT_CCO",
  // Projects
  PROJECT_SETUP: "DOCTYPE_PROJECT_SETUP",
  PROJECT_DASH: "DOCTYPE_PROJECT_DASH",
  PROJECT_PAY_ESTIMATES: "DOCTYPE_PROJECT_PAY_ESTIMATES",
  PROJECT_PAY_ESTIMATE_DETAIL: "DOCTYPE_PROJECT_PAY_ESTIMATE_DETAIL",
  PROJECT_QSHEET: "DOCTYPE_PROJECT_QSHEET",
  PROGRESS_PAYMENTS: "DOCTYPE_PROGRESS_PAYMENTS",
  WEEKLY_NEWSLETTER: "DOCTYPE_WEEKLY_NEWSLETTER",
  PROJECT_ASSIGNMENT: "DOCTYPE_PROJECT_ASSIGNMENT",
  PROJECT_LIST: "DOCTYPE_PROJECT_LIST",
  // Overtime
  OVERTIME_LIST: "DOCTYPE_OVERTIME_LIST",
  // IssueTracker
  ISSUE_TRACKER: "DOCTYPE_ISSUE_TRACKER",
  ISSUE_THREAD: "DOCTYPE_ISSUE_THREAD",
  // QMS
  QMS_DASHBOARD: "DOCTYPE_QMS_DASHBOARD",
  QMS_ADMIN: "DOCTYPE_QMS_ADMIN",
  QMS_CHANGE_MANAGEMENT_TRACKER: "DOCTYPE_QMS_CHANGE_MANAGEMENT_TRACKER",
  QMS_CHANGE_MANAGEMENT_TRACKER_LIST: "DOCTYPE_QMS_CHANGE_MANAGEMENT_TRACKER_LIST",
};
